import dayjs from 'dayjs';

export const getFormattedDate = (date: string, format: string) => dayjs(date).utc().local().format(format);
